import React from 'react';
import LoadingOverlay from 'ggApp/shared/common/LoadingOverlay';

export default {
    search: () => {},
    loading: function Loading() {
        return <LoadingOverlay />;
    },
};
